var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.80555 10.0972L14.8389 19.0694C15.8069 17.9486 21.9361 11.3778 25 20.3528C25 20.3528 24.6778 25 18.0639 25C13.3875 25 8.54861 19.3917 5.16111 16.1861C2.25833 13.4611 0 9.93611 0 6.73056C0 0.161111 4.51667 0 4.51667 0C14.8389 3.525 5.80694 10.0972 5.80694 10.0972",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPhone);
export default __webpack_public_path__ + "static/media/iconPhone.644d0189c705ce80eb97d1692bd40949.svg";
export { ForwardRef as ReactComponent };